import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { ActivityPayoutDetail, ActivityRedemptionDetail } from '@/models/activityModels';
import ApiService from '@/services/ApiService';

const activityApi = createApi({
  reducerPath: 'activityApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getActivityDetail: builder.query<ActivityPayoutDetail | ActivityRedemptionDetail, { id: number; type?: 'payout' | 'redemption' }>({
      queryFn: ({ id, type = 'payout' }) => {
        if (type === 'payout') {
          return ApiService.getPayoutDetails(id)
            .then((response) => ({ data: response.data }))
            .catch((error) => ({ error }));
        }
        return ApiService.getRedemptionDetails(id)
          .then((response) => ({ data: response.data }))
          .catch((error) => ({ error }));
      },
    }),
  }),
});

export default activityApi;

export const { useGetActivityDetailQuery } = activityApi;
